import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Response } from '../../shared/models/response.model';
import { TrigrammeTypeCertification } from './models/trigramme-type-certification.model';
import { CreateRequestTrigrammeType } from './request/create-request';

@Injectable({
  providedIn: 'root',
})
export class TrigrammeTypeCertificationService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/trigrammes-type-certification';

  trouverTous = () => this.#http.get<Response<TrigrammeTypeCertification>>(this.BASE_URL);

  exporter(): Observable<Blob> {
    return this.#http.get(this.BASE_URL + '/export', {
      responseType: 'blob' as const,
    });
  }

  modifier = (trigramme: TrigrammeTypeCertification) =>
    this.#http.put<void>(this.BASE_URL + '/' + trigramme.id, trigramme);

  créer = (data: CreateRequestTrigrammeType) => this.#http.post<void>(this.BASE_URL, data);

  supprimer = (id: string) => this.#http.delete<void>(this.BASE_URL + '/' + id);
}
